import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import rolePower from './comp/power.vue';
import utilRules from '@/libs/rules';
import md5 from 'md5';
var rule = [{
  key: 'accountName',
  name: '员工姓名'
}, {
  key: 'loginAccount',
  name: '登录账号'
}, {
  key: 'accountPassword',
  name: '登录密码'
}, {
  key: 'accountPhone',
  name: '电话',
  validator: 'validatePhone'
}, {
  key: 'positionId',
  name: '角色'
}, {
  key: 'departmentId',
  name: '部门'
}];
var initForm = {
  accountName: '',
  loginAccount: '',
  accountPassword: '',
  accountPhone: '',
  positionId: '',
  departmentId: '',
  positionAuthorities: []
};
import { cloneDeep } from 'lodash';
export default {
  meta: {
    title: '添加员工',
    auth: true,
    authorityValue: 'store-account-management'
  },
  name: 'addStaff',
  components: {
    rolePower: rolePower
  },
  data: function data() {
    return {
      // 表单
      formData: cloneDeep(initForm),
      rules: utilRules(rule),
      buMenOptions: [],
      roleOptions: [],
      props: {
        value: 'departmentId',
        label: 'departmentName'
      }
    };
  },
  created: function created() {
    this.dataBind();
  },
  computed: {
    VUE_APP_LOGIN_SALT: function VUE_APP_LOGIN_SALT() {
      return process.env.VUE_APP_LOGIN_SALT;
    }
  },
  methods: {
    changeRadio: function changeRadio(e) {
      var item = this.roleOptions.find(function (v) {
        return v.positionId === e;
      });
      var rolePower = this.$refs.rolePower;
      rolePower.emitSetRole(item.positionAuthorities);
    },
    handleChange: function handleChange(e) {
      console.log(e);
    },
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, _yield$_this$$api$pos, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.departments();

              case 2:
                data = _context.sent;
                _this.buMenOptions = data; //角色

                _context.next = 6;
                return _this.$api.positions({
                  pageSize: 999
                });

              case 6:
                _yield$_this$$api$pos = _context.sent;
                records = _yield$_this$$api$pos.records;
                _this.roleOptions = records;

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$refs.formData.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
                    var roleList, params;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 15;
                              break;
                            }

                            roleList = _this2.$refs.rolePower.emitRole();
                            params = cloneDeep(_this2.formData);
                            _context2.t0 = Object;
                            _context2.t1 = params;
                            _context2.next = 7;
                            return _this2.confirm(roleList);

                          case 7:
                            _context2.t2 = _context2.sent;
                            params = _context2.t0.assign.call(_context2.t0, _context2.t1, _context2.t2);
                            params.departmentId = params.departmentId[params.departmentId.length - 1];

                            _this2.$set(params, 'accountPassword', md5("".concat(_this2.formData.accountPassword).concat(_this2.VUE_APP_LOGIN_SALT)));

                            _context2.next = 13;
                            return _this2.$api.saveStaff(params);

                          case 13:
                            _this2.$notify.success({
                              title: '成功',
                              message: '添加成功'
                            });

                            _this2.goBack();

                          case 15:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    confirm: function confirm(roleList) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  positionAuthorities: []
                };
                data = cloneDeep(roleList);
                data.forEach(function (v) {
                  var positionLen = v.positionAuthorities.length;

                  if (positionLen > 0) {
                    v.active = true;
                    v.children = v.children.map(function (k) {
                      if (v.positionAuthorities.includes(k.authorityValue)) {
                        return _objectSpread(_objectSpread({}, k), {}, {
                          active: true
                        });
                      } else {
                        return _objectSpread(_objectSpread({}, k), {}, {
                          active: false
                        });
                      }
                    });
                    params.positionAuthorities.push(v);
                  } else {
                    if (v.check) v.active = v.check;
                    v.children = v.children.map(function (k) {
                      return _objectSpread(_objectSpread({}, k), {}, {
                        active: false
                      });
                    });
                    params.positionAuthorities.push(v);
                  }
                });
                return _context4.abrupt("return", params);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};